import { render, staticRenderFns } from "./ExternalContentPage.vue?vue&type=template&id=392acef0"
import script from "./ExternalContentPage.vue?vue&type=script&lang=js"
export * from "./ExternalContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports